module.exports = __webpack_public_path__ + "static/img/bg-qrcode-share.f2fa6f4e.png";